import { isRequiredText, strMax } from './utils';
export const validateBoardName = [
    isRequiredText('ボードの名前を入力してください'),
    strMax(30, 'ボードの名前は30文字以内で入力してください'),
];
export default validateBoardName;
